module.exports = __webpack_public_path__ + "img/专利许可件数.eaf07ec7.png";